import { useSelectInstallationRoomFieldQuery } from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  name: string;
  displayName: string;
}

export function useQuery(id: string) {
  const tuple = useSelectInstallationRoomFieldQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.project?.rooms.map((node) => ({
        id: node.name,
        name: node.name ?? '',
        displayName: node.name ?? ''
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
